import {
  EquipmentMetric,
  EquipmentType,
  SystemType,
} from './systemTypes.models';

export interface SystemTypesState {
  ids: string[];
  entities: Record<string, SystemType>;
  metrics: {
    raw: EquipmentMetric[];
    efficiency: { heating: string[]; cooling: string[] };
    load: { heating: string[]; cooling: string[] };
  };
  equipmentTypes: EquipmentType[];
  isLoaded: boolean;
  isLoading: boolean;
  error: string | null;
}

export const initState: SystemTypesState = {
  ids: [],
  entities: {},
  metrics: {
    raw: [],
    efficiency: { heating: [], cooling: [] },
    load: { heating: [], cooling: [] },
  },
  equipmentTypes: [],
  isLoaded: false,
  isLoading: true,
  error: null,
};

type Action =
  | { type: 'FETCH_SYSTEM_OPTIONS' }
  | {
      type: 'FETCH_SYSTEM_OPTIONS_SUCCESS';
      payload: {
        systemTypes: SystemType[];
        metrics: {
          raw: EquipmentMetric[];
          efficiency: { heating: string[]; cooling: string[] };
          load: { heating: string[]; cooling: string[] };
        };
        equipmentTypes: EquipmentType[];
      };
    }
  | { type: 'FETCH_SYSTEM_OPTIONS_FAILURE'; payload: { error: string } }
  | {
      type: 'SET_LOADING_STATE';
      payload: { isLoading: boolean; isLoaded: boolean };
    };

export const systemTypesReducer = (
  state: SystemTypesState,
  action: Action
): SystemTypesState => {
  switch (action.type) {
    case 'FETCH_SYSTEM_OPTIONS':
      return {
        ...state,
        error: null,
        isLoading: true,
        isLoaded: state.isLoaded || !!state.ids.length,
      };

    case 'FETCH_SYSTEM_OPTIONS_SUCCESS':
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        ids: [
          ...new Set([
            ...state.ids,
            ...action.payload.systemTypes.map((type) => type.systemTypeId),
          ]),
        ],
        entities: {
          ...action.payload.systemTypes.reduce(
            (acc, type) => ({
              ...acc,
              [type.systemTypeId]: type,
            }),
            state.entities
          ),
        },
        metrics: action.payload.metrics,
        equipmentTypes: action.payload.equipmentTypes,
      };

    case 'FETCH_SYSTEM_OPTIONS_FAILURE':
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        error: action.payload.error,
      };

    case 'SET_LOADING_STATE':
      return { ...state, ...action.payload };

    default:
      return state;
  }
};
